module.exports = __webpack_public_path__ + "media/images/my_apps/atlas 2017-3_app icon_rounded_115-61d366b7acc067c6d5f70f9c00c20783.png";